<template>
    <div id="filetree">
        <v-container fluid class="pa-0">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-card :height="avail_height-120">
                        <v-banner sticky color="black" v-if="!mobileView">
                            <v-container fluid class="pa-0 pt-2">
                                <v-row no-gutters>
                                    <v-col cols="2">
                                        <v-btn label small depressed width="170px" :class="explorerView ? 'blue--text caption pt-1 mt-1' : 'caption pt-1 mt-1'">
                                            <v-container fluid class="pa-0">
                                                <v-switch
                                                    v-model="explorerView"
                                                    class="mb-3 float-left"
                                                    height="18"
                                                ></v-switch>
                                            </v-container>
                                            <div class="mb-1" @click="explorerView=!explorerView">Explorer View</div>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="8">
                                        <v-text-field
                                            v-model="project_path_value"
                                            label="Jump to folder"
                                            clearable
                                            dense
                                            :hint="project_path_hint"
                                            v-on:keyup.enter="loadProjectPath"
                                            v-on:click:clear="clearProjectPath"
                                            class="body-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <!--v-btn v-if="ispassword && (files_selected || sequences_selected)" depressed x-small color="error" class="float-right mt-2" @click="deleteItems">
                                            Delete
                                        </v-btn>
                                        <v-btn v-if="files_selected || sequences_selected" depressed x-small color="success" class="float-right mr-1 mt-2" @click="downloadItems">
                                            Download
                                        </v-btn>

                                        <v-btn v-if="ispassword && (!files_selected && sequences_selected && sim_preview_enabled)" depressed x-small color="error" class="float-right mt-2" @click="previewSeqs">
                                            Preview
                                        </v-btn-->
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-banner>
                        <v-card-text class="pa-1">
                            <v-container fluid class="pa-0">
                                <v-row v-if="explorerView" no-gutters>
                                    <v-col cols="6">
                                        <div :style="`height:${avail_height-215}px`" class="overflow-auto">
                                            <div style="width:max-content">
                                                <v-container v-if="!root_exists" class="pa-0">
                                                    <div class="red--text">Invalid Path</div>
                                                </v-container>
                                                <TreeItem
                                                    v-if="root_exists"
                                                    class="item"
                                                    :item="treeItems"
                                                    :view="explorerView"
                                                    :selectedNode="selected_node"
                                                    @make-folder="makeFolder"
                                                    @add-item="addItem"
                                                    @delete-item="deleteItem"
                                                    @preview-item="previewItem"
                                                    @download-item="downloadItem"
                                                    @upload-to-item="uploadToItem"
                                                    @toggle-item="toggleItem"
                                                    @reload-item="reloadItem"
                                                    @load-more-items="loadMoreItems"
                                                    @activate-item="activateItem"
                                                    @select-deselect-item="selectDeselectItem"
                                                    @select-deselect-seqs="selectDeselectSeqs"
                                                ></TreeItem>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="6">
                                        <div :style="`height:${avail_height-215}px;background-color:#292929;`" class="overflow-auto">
                                        <div v-if="selected_node" style="width:max-content;">
                                            <div v-for="item in selected_node.children" :key="item.path">
                                                <div v-if="!item.is_dir && !item.is_seq" style="clear:both;overflow:hidden">
                                                    <!--v-checkbox
                                                        v-model="item.selected_files"
                                                        :value="item.path"
                                                        dense
                                                        color="blue"
                                                        style="width:24px;float:left;"
                                                        class="ma-0 pa-0"
                                                        hide-details
                                                        @change="selectDeselectItem(item)"
                                                    ></v-checkbox-->
                                                    <span class="mx-2">{{item.Name}}</span>
                                                    <span class="caption grey--text" v-if="!item.is_seq">({{humanFileSize(item.Size)}}) - {{(item.LastModified)}}</span>
                                                    <!--v-chip v-if="item.deleting" x-small color="red" class="ml-1">deleting</v-chip>
                                                    <v-btn
                                                        v-if="item.is_seq && sim_preview_enabled" plain x-small color="primary"
                                                        v-on:click.stop="previewItem(item)" title="preview"
                                                        class="pa-0 ma-0"
                                                    >
                                                        <v-icon small>mdi-movie-play-outline</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        v-if="!item.deleting" plain x-small color="primary"
                                                        v-on:click.stop="downloadItem(item)" title="downloads"
                                                        class="pa-0 ma-0"
                                                    >
                                                        <v-icon small>mdi-download</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        v-if="ispassword && !item.deleting" plain x-small color="primary"
                                                        v-on:click.stop="deleteItem(item)"
                                                    >
                                                        <v-icon small>mdi-delete</v-icon>
                                                    </v-btn-->
                                                </div>
                                            </div>
                                            <v-btn v-if="selected_node.load_more && !selected_node.loading" depressed x-small color="green" class="ml-6 my-2" @click="loadMoreItems(selected_node)">
                                                Load More
                                            </v-btn>
                                            <div style="height:25px">

                                            </div>
                                            <!--v-progress-circular
                                                v-if="selected_node.load_more && selected_node.loading" class="mt-2 float-left"
                                                :size="10" :width="2" indeterminate color="primary"
                                            ></v-progress-circular-->
                                        </div>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row v-else>
                                    <v-col cols="12">
                                        <div :style="`height:${avail_height-215}px`" class="overflow-auto">
                                            <div style="width:max-content;">
                                                <v-container v-if="!root_exists" fluid class="pa-0">
                                                    <div class="red--text">Invalid Path</div>
                                                </v-container>
                                                <TreeItem
                                                    v-if="root_exists"
                                                    class="item"
                                                    :item="treeItems"
                                                    :view="explorerView"
                                                    :selectedNode="selected_node"
                                                    @make-folder="makeFolder"
                                                    @add-item="addItem"
                                                    @delete-item="deleteItem"
                                                    @preview-item="previewItem"
                                                    @download-item="downloadItem"
                                                    @upload-to-item="uploadToItem"
                                                    @toggle-item="toggleItem"
                                                    @reload-item="reloadItem"
                                                    @load-more-items="loadMoreItems"
                                                    @activate-item="activateItem"
                                                    @select-deselect-item="selectDeselectItem"
                                                    @select-deselect-seqs="selectDeselectSeqs"
                                                ></TreeItem>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
            v-model="action_dialog"
            hide-overlay
            persistent
            width="300"
        >
            <v-card
                color="green"
                dark
            >
                <v-card-text>
                    {{ action_message }}
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="download_folder_dialog" v-on:click:outside="close_download_dialog()" @keydown.esc="close_download_dialog()" max-width="600px" style='z-index:1001;'>
            <v-form width="500" lazy-validation>
                <v-card>
                <v-alert v-if="download_folder_error" class="error my-0 pa-2" tile>
                    <v-icon small class="pb-1">warning</v-icon>
                    <span class="subtitle-1 font-weight-medium pl-2">{{download_folder_error}}</span>
                </v-alert>
                <v-btn class="float-right" fab dark small text @click="close_download_dialog">
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>
                <v-card-title>
                    <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Please select a folder to download</span>
                </v-card-title>
                <v-card-text class="py-0">
                    <v-container class="pa-0">
                        <v-form>
                            <v-row>
                                <v-col class="body-2">
                                    <v-radio-group
                                        v-model="path_type"
                                        mandatory
                                        dense
                                        class="caption"
                                    >
                                        <v-radio
                                            class="caption"
                                            label="Absolute path (caution: files with the same name from different folders will be overwritten)"
                                            value="absolute"
                                        ></v-radio>
                                        <v-radio
                                            v-if="platform != 'windows'"
                                            label="Relative to project folder (folder structure will be maintained)"
                                            value="relative"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                    <v-text-field
                                        v-model="download_folder"
                                        append-icon="mdi-folder"
                                        clear-icon="mdi-close-circle"
                                        readonly
                                        type="text"
                                        small
                                        @click:append="select_folder_dialog=true"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-spacer></v-spacer>
                                    <br/>
                                    <span class="float-left body-2" v-if="path_type=='relative'">{{additional_path}}</span>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error darken-1" x-small depressed @click="close_download_dialog()">Cancel</v-btn>
                    <v-btn color="success darken-1" x-small depressed @click="download_files()">Download</v-btn>
                </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="upload_files_dialog" v-on:click:outside="close_upload_dialog($event)" @keydown.esc="close_upload_dialog($event)" max-width="600px" style='z-index:1001;'>
            <v-form width="500" lazy-validation>
                <v-card>
                    <v-alert v-if="upload_files_error && !upload_file_list.length" class="error my-0 pa-2" tile>
                        <v-icon small class="pb-1">warning</v-icon>
                        <span class="subtitle-1 font-weight-medium pl-2">{{upload_files_error}}</span>
                    </v-alert>
                    <v-btn class="float-right" fab dark small text @click="close_upload_dialog">
                        <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                    <v-card-title>
                        <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Upload Folder/Files</span>
                    </v-card-title>
                    <v-card-text class="py-0">
                        <v-container class="pa-0">
                            <v-row>
                                <v-col class="body-2">
                                    <input type="file" multiple ref="fileinp" @input="select_files" style="display: none">
                                    <v-btn class="float-right" color="orange" x-small depressed @click="select_files_dialog=true">
                                        <v-icon x-small>
                                            mdi-file-plus
                                        </v-icon>
                                        Add Files
                                    </v-btn>
                                    <v-btn class="float-right mr-1" color="orange" x-small depressed @click="select_folder_dialog=true">
                                        <v-icon x-small>
                                            mdi-folder-plus
                                        </v-icon>
                                        Add Folder
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-if="upload_file_list.length > 0">
                                <v-col cols="12">
                                    <v-card
                                        elevation="16"
                                        class="mx-auto"
                                        :height="avail_height - 200"
                                    >
                                        <v-container fluid class="pa-0">
                                        <div :style="`height:${avail_height-215}px`" class="overflow-auto">
                                            <v-list dense>
                                                <v-list-item v-for="item in upload_file_list" :key="item" class="pa-0 ma-0" style="border-bottom:1px solid #ffffff1f;min-height:unset !important;">
                                                    <v-list-item-content class="pa-0 caption">
                                                        {{ item }}
                                                    </v-list-item-content>

                                                    <v-list-item-action class="ma-0">
                                                        <v-btn x-small fab  height="16px" width="16px" depressed color="red" @click="remove_selected_file(item)">
                                                            <v-icon x-small>
                                                                mdi-close
                                                            </v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </v-list>
                                        </div>
                                        </v-container>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col class="body-2 red--text">
                                    No files seleted yet
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn x-small color="error darken-1" depressed @click="close_upload_dialog()">Cancel</v-btn>
                        <v-btn x-small color="success darken-1" depressed @click="upload_files()">Upload</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--v-dialog v-model="select_folder_dialog" persistent :retain-focus="false" v-on:click:outside="close_select_folder_dialog($event)" @keydown.esc="close_select_folder_dialog($event)" max-width="600px" style='z-index:2001;'>
            <v-card>
                <v-btn class="float-right" fab dark small text @click="close_select_folder_dialog">
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="pa-1">
                    <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Select Folder</span>
                </v-card-title>
                <v-card-text class="pa-1">
                    <SelectFolder :avail_height="avail_height" :set_download_folder="set_download_folder" :close_select_folder_dialog="close_select_folder_dialog" />
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="select_files_dialog" persistent :retain-focus="false" v-on:click:outside="close_select_files_dialog($event)" @keydown.esc="close_select_files_dialog($event)" max-width="600px" style='z-index:2001;'>
            <v-card>
                <v-btn class="float-right" fab dark small text @click="close_select_files_dialog">
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="pa-1">
                    <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Select Files</span>
                </v-card-title>
                <v-card-text class="pa-1">
                    <SelectFiles :key="Date.now()" :avail_height="avail_height" :set_upload_files="set_upload_files" :close_select_files_dialog="close_select_files_dialog" />
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="sim_previews_dialog" persistent :retain-focus="false" v-on:click:outside="close_sim_previews_dialog($event)" @keydown.esc="close_sim_previews_dialog($event)" style='z-index:2001;'>
            <v-card>
                <v-btn class="float-right" fab dark small text @click="close_sim_previews_dialog">
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="pa-1">
                    <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Available Previews for {{sim_previews_seq && sim_previews_seq.full_path}}</span>
                </v-card-title>
                <v-card-text class="pa-1">
                    <SimPreviewsDialog 
                        v-if="sim_previews_seq" :avail_height="avail_height" :sim_previews_seq="sim_previews_seq"
                        :close_sim_previews_dialog="close_sim_previews_dialog" :acknowledge_action="acknowledge_action"
                    />
                </v-card-text>
            </v-card>
        </v-dialog-->
        <v-dialog
            v-model="creating_preview"
            hide-overlay
            persistent
            width="300"
        >
            <v-card
                color="primary"
                dark
            >
                <v-card-text>
                    Creating preview...
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="checking_preview"
            persistent
            :width="invalid_previews.length ? 'auto' : 300"
        >
            <v-card
                dark
            >
                <v-card-text class="caption font-weight-bold">
                    <div v-if="invalid_previews.length">
                        The following sequences need to be converted:
                        <div v-if="invalid_previews.length" class="caption">
                            <div v-for="prev_seq in invalid_previews" :key="prev_seq.file_path">{{ prev_seq.file_path }}</div>
                        </div>
                        <br/>
                        Submit jobs to convert?  You will need to wait for the conversions to complete before you can preview them.
                        <v-card-actions>
                            <v-btn
                                depressed
                                :loading="converting_preview"
                                x-small color="success"
                                title="Convert"
                                @click="convert_previews"
                            >
                                Convert
                            </v-btn>
                            <v-btn
                                depressed
                                x-small color="error"
                                title="Cancel"
                                @click="checking_preview=false;invalid_previews=[];"
                            >
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </div>
                    <div v-else>
                        Checking preview...
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        ></v-progress-linear>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="preview_failed"
            hide-overlay
            persistent
            width="300"
        >
            <v-card
                color="error"
                dark
            >
                <v-card-text>
                    {{preview_error}}
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="preview_success"
            hide-overlay
            persistent
            width="300"
        >
            <v-card
                color="success"
                dark
            >
                <v-card-text>
                    {{preview_message}}
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import path from 'path';
import axios from 'axios';

import TreeItem from './FileExplorer.vue';
//import SelectFiles from './SelectFiles.vue';
//import SelectFolder from './SelectFolder.vue';
//import { log } from 'console';
//import SimPreviewsDialog from './SimPreviewsDialog';

export default {
    name: "FileTree",
    //components: {TreeItem, SelectFiles, SelectFolder, SimPreviewsDialog},
    components: {TreeItem},
    props: {
      project: {
        type: String
      },
      project_path: {
        type: String
      },
      storage: {
        type: String
      },
      show_tab: {
        type: Function
      },
      set_project_path: {
        type: Function
      },
      avail_height: {
        type: Number
      }
    },
    data: () => ({
        platform: null,
        ispassword: false,
        explorerView: true,
        mobileView: false,
        project_root_name: null,
        project_root_path: null,
        treeItems: {},
        default_count: 500,
        path_type: null,
        select_folder_dialog: false,
        select_files_dialog: false,
        download_folder: null,
        download_folder_dialog: false,
        download_folder_error: null,
        upload_folder: null,
        upload_folder_storage: null,
        upload_files_dialog: false,
        upload_files_error: null,
        sim_previews_dialog: false,
        upload_file_list: [],
        delete_path_list: {},
        selected_files:{},
        files_selected: false,
        selected_sequences: {},
        sequences_selected: false,
        action_dialog: false,
        action_message: null,
        root_exists: true,
        selected_node: null,
        preview_list: [],
        invalid_previews: [],
        sim_previews_seq: null,
        sim_preview_enabled: false,
        creating_preview: false,
        checking_preview: false,
        converting_preview: false,
        preview_success: false,
        preview_failed: false,
        preview_message: null,
        preview_error: null
    }),
    created () {
        if (["xs", "sm"].indexOf(this.$vuetify.breakpoint.name) > -1){
            this.explorerView = false
            this.mobileView = true
        }

        var platform = window.navigator.platform;
        platform.startsWith("Win") ? this.platform = "windows" : this.platform = platform;
        this.additional_path = path.join(path.sep, this.project)
        this.project_path_hint = `e.g. ${this.project}/render_results`;

        this.project_root_path = this.project_path;
        if (!this.project_root_path.startsWith(this.project)){
            this.project_root_path = path.join(this.project, this.project_root_path);
        }
        this.project_root_name = this.project_root_path;

        this.treeItems = {
            id: -1,
            Name: this.project_root_name,
            path: `${this.project_root_path}/`,
            children: [],
            lts: this.storage,
            time: 0,
            is_dir: true,
            open: false,
            invalid: false,
            loaded: false
        }

        this.project_path_value = this.project_path;
        if (this.project_path_value == this.project){
            this.project_path_value = "";
        }
        if (this.$session.exists()) {      
            this.current_user = this.$session.get("current_user")
            if (this.current_user.ispassword){
                this.ispassword = true;
            }
        }
        this.sim_preview_enabled = JSON.parse(localStorage.getItem("sim_preview_enabled")) || false
        this.fetchFiles(this.treeItems);
    },
    watch: {
        download_folder: {
            handler: 'select_folder'
        }
    },
    methods: {
        loadProjectPath: function() {
            this.project_path_value = this.project_path_value.replace(/^\//, '');
            this.project_path_value = this.project_path_value.replace(/\/$/, '');
            this.set_project_path(this.project_path_value);
        },
        clearProjectPath: function() {
            this.set_project_path(null);
        },
        fetchFiles: async function(item, index=0){
            this.$set(item, "loading", true);
            if (!item.path.startsWith(this.project)){
                item.path = path.join(this.project, item.path);
            }

            let count = item.count || this.default_count;
            console.log(item.path);
            let listing_url = `https://${this.$assetAPI}/user/resource?path=${encodeURIComponent(item.path)}&index=${index}&count=${count}&sequence=true`;
            if (item.is_seq){
                listing_url = `https://${this.$assetAPI}/user/resource?expand_sequence=${encodeURIComponent(item.path)}&index=${index}&count=${count}&sequence=true`;
            }
            return axios.get(listing_url)
            .then(resp => {
                let children = index ? item.children : [];
                let resp_json = resp.data.files;
                resp_json.forEach((file) => {
                    file.id = `file_${file.Key}`;
                    file.parent = item;
                    //file.selected = this.selected_files.hasOwn(file.Key) ? file.Key : null
                    //file.selected_seqs = this.selected_sequences.hasOwn(file.Key) ? file.Key : null
                    file.is_seq = file.Sequence ? true : false;
                    file.is_dir = file.Size == null ? true : false;
                    if (file.is_dir || file.is_seq ){
                        file.is_dir = true;
                        file.path = `${file.Key}`
                        file.children = [];
                    }
                    children.push(file);
                })

                if (!this.selected_node) this.selected_node = item;
                this.$set(item, "children", children)
                this.$set(item, "open", true);
                this.$set(item, "loaded", true);
                this.$set(item, "loading", false);

                if (resp_json.length >= this.default_count){
                    this.$set(item, "load_more", true);
                }else{
                    this.$set(item, "load_more", false);
                }
            })
            .catch(error => {
                if (error.response && (error.response.status == 400 || error.response.status == 404)){
                    if (item.id == -1){
                        this.root_exists = false;
                    }else{
                        this.reloadItem(item.parent);
                        this.selected_node = null;
                    }
                }
            })
        },
        toggleItem: function(item) {
            if (item.loaded){
                this.$set(item, "open", !item.open);
            }else{
                this.fetchFiles(item);
            }
        },
        reloadItem: function(item){
            this.$set(item, "loaded", false);
            this.$set(item, "children", []);
            this.$set(item, "load_more", false);
            this.fetchFiles(item);
        },
        loadMoreItems: function(item){
            let index = item.children.length;
            this.fetchFiles(item, index);
        },
        makeFolder: function(item) {
            this.$set(item, "children", []);
            this.addItem(item);
        },
        addItem: function(item) {
            item.children.push({
                name: "new stuff"
            });
        },
        close_download_dialog() {
            this.download_folder_dialog = false;
            this.download_folder_error = null;
        },
        close_upload_dialog() {
            this.upload_files_dialog = false;
            this.upload_files_error = null;
        },
        close_select_files_dialog(){
            this.select_files_dialog = false;
        },
        close_sim_previews_dialog(){
            this.sim_previews_seq = null;
            this.sim_previews_dialog = false;
        },
        set_upload_files(sel_files=[]){
            for (var i=0;i<sel_files.length;i++){
                let sel_file = sel_files[i]
                if (this.upload_file_list.indexOf(sel_file) < 0) this.upload_file_list.push(sel_file)
            }
        },
        close_select_folder_dialog(){
            this.select_folder_dialog = false;
        },
        set_download_folder(sel_folder){
            this.download_folder = null
            setTimeout(()=>{
                this.download_folder = sel_folder
            },100)
        },
        acknowledge_action(msg) {
            this.action_dialog = true;
            this.action_message = msg;
            setTimeout(()=>{
                this.action_dialog = false;
                this.action_message = null;
            }, 2000)
        },
        activateItem: function(item) {
            if((item.is_dir || item.is_seq) && !item.loaded){
                this.fetchFiles(item);
            }
            this.selected_node = item;
        },
        selectDeselectItem: function(item) {
            /*
            if (Object.keys(this.selected_sequences).length){
                item.selected_files = null;
                return;
            }
            */
            if (this.selected_files.hasOwn(item.path)){
                delete this.selected_files[item.path];
            }else{
                this.selected_files[item.path] = item;
            }
            this.files_selected = Object.keys(this.selected_files).length ?  true : false;
        },
        selectDeselectSeqs: function(item) {
            /*
            if (Object.keys(this.selected_files).length){
                item.selected_sequences = null;
                return;
            }
            */
            if (this.selected_sequences.hasOwn(item.path)){
                delete this.selected_sequences[item.path];
            }else{
                this.selected_sequences[item.path] = item;
            }
            this.sequences_selected = Object.keys(this.selected_sequences).length ?  true : false;
        },
        previewSeqs: function() {
            let confirm_preview = confirm(`Are you sure, do you want to preview the selected sequence(s)?`)
            if (!confirm_preview){
                return false;
            }
            this.sequence_path_list = [];
            for (var key in this.selected_sequences) {
                if (this.selected_sequences.hasOwn(key)) {
                    let sel_item = this.selected_sequences[key];
                    this.sequence_path_list.push(sel_item.path);
                }
            }
            this.previewItems();
        },
        previewItem: function(item) {
            //let routeData = this.$router.resolve({name: 'previews', params: {project: item.project, file_paths: [item.path]}});
            //window.open(routeData.href, '_blank');
            //this.create_previews([item.path]);
            this.preview_list = [item.path];
            this.check_previews();
        },
        previewItems: function() {
            //let routeData = this.$router.resolve({name: 'previews', params: {project: this.project, file_paths: this.sequence_path_list}});
            //window.open(routeData.href, '_blank');
            //this.create_previews(this.sequence_path_list);
            this.preview_list = this.sequence_path_list
            this.check_previews();
        },
        check_previews: function() {
            this.checking_preview = true;
            var seq_path_list = this.preview_list.map(seq => { return `/${seq}` })
            var post_json = {
                "project": this.project,
                "file_paths": seq_path_list
            }
            axios.post(`http://localhost:8090/sim-previews?action=validate`, post_json)
            .then((resp) => {
                let previews_resp = resp.data.data || []
                this.invalid_previews = previews_resp.filter((prev)=>{return prev.require_preview_prep});

                if (!this.invalid_previews.length){
                    this.create_previews();
                    this.checking_preview = false;
                }
            })
            .catch((err) => {
                this.checking_preview = false;
                this.invalid_previews = []
                this.preview_failed = true;
                this.preview_error = (err.response && err.response.data) ? err.response.data.error : "No sim previews available"
                setTimeout(()=>{this.preview_failed = false}, 7000)
            })
        },
        convert_previews: function() {
            this.converting_preview = true;
            var seq_path_list = this.invalid_previews.map(prev => { return prev.file_path })
            var post_json = {
                "project": this.project,
                "file_paths": seq_path_list
            }
            axios.post(`http://localhost:8090/sim-previews?action=preview-prep`, post_json)
            .then(() => {
                this.checking_preview = false;
                this.converting_preview = false;
                this.invalid_previews = []
                this.preview_success = true;
                this.preview_message = "Job submitted for conversion of selected sequence(s)"
                setTimeout(()=>{
                    this.preview_success = false;
                    this.show_tab(0);
                }, 15000)
            })
            .catch((err) => {
                this.checking_preview = false;
                this.invalid_previews = []
                this.converting_preview = false
                this.preview_failed = true;
                this.preview_error = (err.response && err.response.data) ? err.response.data.error : "No sim previews available"
                setTimeout(()=>{this.preview_failed = false}, 7000)
            })
        },
        create_previews: function(){
            this.creating_preview = true;
            var seq_path_list = this.preview_list.map(seq => { return `/${seq}` })
            let post_json = {
                project : this.project,
                file_paths : seq_path_list
            }

            axios.post(`http://localhost:8090/sim-previews`, post_json)
            .then((resp) => {
                this.creating_preview = false;
                let new_preview = resp.data.data || {}
                let routeData = this.$router.resolve({name: 'previews', params: {preview_id: new_preview.uuid}})
                window.open(routeData.href, '_blank');
             })
            .catch((err) => {
                this.creating_preview = false;
                this.preview_failed = true;
                this.preview_error = (err.response && err.response.data) ? err.response.data.error : "No sim previews available"
                setTimeout(()=>{this.preview_failed = false}, 7000)
            })
        },
        downloadItem: function(item) {
            this.download_path_list = {};
            this.download_path_list[item.path] = [item.time || 0, item.size || 0, item.lts, item.is_seq, item.in_archive];
            this.path_type = "absolute";
            this.download_folder_dialog = true;
            this.select_folder_dialog = true;
        },
        downloadItems: function() {
            this.download_path_list = {};
            var download_file_list = {...this.selected_files, ...this.selected_sequences}
            for (var key in download_file_list) {
                if (download_file_list.hasOwn(key)) {
                    let sel_item = download_file_list[key];
                    this.download_path_list[sel_item.path] = [sel_item.time, sel_item.size, sel_item.lts, sel_item.is_seq, sel_item.in_archive];
                }
            }
            this.path_type = "absolute";
            this.download_folder_dialog = true;
            this.select_folder_dialog = true;
        },
        download_files: function(){
            let post_json = {
                project_name: this.project,
                target_dir: this.download_folder,
                source_path: this.download_path_list,
                download_rel: (this.path_type == "relative") ? true : false
            }

            axios.post(`http://localhost:8090/download_files`, post_json)
            .then(() => {
                this.download_folder_dialog = false;
                this.acknowledge_action("Downloading file(s)...");
            })
            .catch(error => {
                if (error.response){
                    if (error.response.status == 401){
                        this.$session.destroy();
                        this.$router.push('/login');
                    }else{
                        this.download_folder_error = error.response.data;
                    }
                }else{
                    this.download_folder_error = error
                }
            })
        },
        uploadToItem(item){
            this.upload_file_list = []
            this.upload_files_dialog = true;
            this.upload_folder = item.path;
            this.upload_folder_storage = item.lts;
            //this.open_file_dialog();
        },
        open_file_dialog() {
            this.$refs.fileinp.click();
        },
        select_files(){
            let up_sel_files = this.$refs.fileinp.files;
            for (let i=0;i<up_sel_files.length;i++){
                let sel_file = up_sel_files[i];
                if (this.upload_file_list.indexOf(sel_file.path) < 0){
                    this.upload_file_list.push(sel_file.path);
                }
            }
            this.$refs.fileinp.value = "";
        },
        remove_selected_file(sel_file){
            let sel_file_idx = this.upload_file_list.indexOf(sel_file);
            if (sel_file_idx > -1){
                this.upload_file_list.splice(sel_file_idx, 1);
            }
        },
        select_folder(){
            let sel_folder = this.download_folder;
            if (sel_folder){
                if (this.upload_file_list.indexOf(sel_folder) < 0){
                    this.upload_file_list.push(sel_folder);
                }
            }
        },
        upload_files(){
            this.upload_files_error = null;
            if (!this.upload_file_list.length){
                this.upload_files_error = "Please select some files";
                return;
            }

            let post_json = {
                project_name: this.project,
                target_dir: this.upload_folder,
                target_storage: this.upload_folder_storage,
                source_path_list: this.upload_file_list
            }

            axios.post(`http://localhost:8090/upload_files_to_path`, post_json)
            .then(() => {
                this.upload_files_dialog = false;
                this.acknowledge_action("Uploading file(s)...");
                /*
                if (this.ispassword){
                    this.show_tab(3);
                }else{
                    this.show_tab(2);
                }
                */
                this.upload_file_list = [];
            })
            .catch(error => {
                if (error.response){
                    if (error.response.status == 401){
                        this.$session.destroy();
                        this.$router.push('/login');
                    }else{
                        this.upload_files_error = error.response.data;
                    }
                }else{
                    this.upload_files_error = error
                }
            })
        },
        deleteItem: function(item) {
            let confirm_delete = confirm(`Are you sure, do you want to delete ${item.Name}?`)
            if (!confirm_delete){
                return false;
            }
            this.$set(item, "deleting", true);
            this.delete_path_list = {};
            this.delete_path_list[item.path] = {path: item.path, storage: item.lts, sequence: item.is_seq};
            this.delete_files();
            setTimeout(() => {
                this.reloadItem(item.parent);
            }, 5000)
        },
        deleteItems: function() {
            let confirm_delete = confirm(`Are you sure, do you want to delete the selected file(s)?`)
            if (!confirm_delete){
                return false;
            }
            this.delete_path_list = {};
            let reload_path_list = {};

            var delete_file_list = {...this.selected_files, ...this.selected_sequences}
            for (var key in delete_file_list) {
                if (delete_file_list.hasOwn(key)) {
                    let sel_item = delete_file_list[key];
                    this.$set(sel_item, "deleting", true);
                    this.delete_path_list[sel_item.path] = {path: sel_item.path, storage: sel_item.lts, sequence: sel_item.is_seq};

                    if (!reload_path_list.hasOwn(sel_item.parent.path)){
                        reload_path_list[sel_item.parent.path] = sel_item.parent;
                    }
                }
            }
            this.delete_files();
            setTimeout(() => {
                for (var key in reload_path_list){
                    if (reload_path_list.hasOwn(key)) {
                        let rel_item = reload_path_list[key];
                        this.reloadItem(rel_item);
                    }
                }
            }, 5000)
        },
        delete_files: function(){
            let path_list = [];
            for (var key in this.delete_path_list) {
                if (this.delete_path_list.hasOwn(key)) {
                    path_list.push(this.delete_path_list[key])
                }
            }
            let post_json = {
                path_list: path_list
            }

            axios.post(`http://localhost:8090/project/${this.project}/delete_files`, post_json)
            .then(() => {
                this.selected_files = {}
                this.selected_sequences = {}
            })
            .catch(error => {
                if (error.response && error.response.status == 401){
                    this.$session.destroy();
                    this.$router.push('/login');
                }
            })
        },
        humanFileSize(bytes, si=false, dp=1) {
            const thresh = si ? 1000 : 1024;
            if (Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }

            const units = si 
                ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
                : ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                //: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
            let u = -1;
            const r = 10**dp;

            do {
                bytes /= thresh;
                ++u;
            } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

            return bytes.toFixed(dp) + ' ' + units[u];
        },
        to_local_datetime(utc_datetime){
            let utc_dt_string = `${utc_datetime}Z`;
            let local_dt = new Date(utc_dt_string);
            let year = local_dt.getFullYear();
            let month = local_dt.getMonth() < 9 ? `0${(local_dt.getMonth()+1)}` : (local_dt.getMonth()+1);
            let date = local_dt.getDate() < 10 ? `0${local_dt.getDate()}` : local_dt.getDate();
            let hours = local_dt.getHours() < 10 ? `0${local_dt.getHours()}` : local_dt.getHours();
            let mins = local_dt.getMinutes() < 10 ? `0${local_dt.getMinutes()}` : local_dt.getMinutes();
            let secs = local_dt.getSeconds() < 10 ? `0${local_dt.getSeconds()}` : local_dt.getSeconds();
            let local_st_string = `${year}-${month}-${date} ${hours}:${mins}:${secs}`;
            return local_st_string;
        }
    }
}
</script>
